import { getLocalStorage, setLocalStorage } from "@utils/localStorage";
import { DEFAULT_API_PATH, DEFAULT_API_PATH_PROD } from "@src/config/request";

// 使用 Ctrl⌃ + Shift⇧ + Alt⌥ + A 切換 API Path
window.addEventListener('keydown', keydown);

function keydown() {
  const isDevSite = window.globalData.APP_ENV === 'local';

  if(isDevSite) {
    const e = event || window.event;
    if(e.ctrlKey && e.shiftKey && e.altKey && e.keyCode === 65) {
      const isSetApiDev = Boolean(getLocalStorage('set.isApiDev'));

      const isApiDev = isSetApiDev
        ? !isSetApiDev
        : DEFAULT_API_PATH === DEFAULT_API_PATH_PROD;

      setLocalStorage('set.isApiDev', isApiDev);

      alert(`【 Ctrl⌃ + Shift⇧ + Alt⌥ + A 】 \n\n API 切換至${isApiDev
        ? '開發者模式'
        : '正式模式'} \n 頁面將重新整理`);

      window.location.reload();
    }
  }
}
